






import { Vue, Component, Prop } from 'vue-property-decorator';
import { ProductDetailsViewModel, RackConfigurationViewObject } from '@/types/apiServerContract';
import rackStartEditModalService from '@/project/app/client-pages/rack-configurator/rackStartEditModal.service';
import Api from '@/project/http/Api.service';
import serverContextService from '@/core/serverContext.service';
import authService from '@/core/auth/auth.service';
import { UrlQueryKey } from '@/core/urlQueryKey';

@Component({})
export default class RackStartEditButton extends Vue {
    @Prop({ required: true }) product!: ProductDetailsViewModel;
    configurations: RackConfigurationViewObject[] | null = null;

    get showRackEditButton(): boolean {
        return !!this.product?.isRackConfigurable && !!serverContextService.settings?.rackConfiguratorPage;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    async handleClickOnRackEdit() {
        if (this.isUserLoggedIn) {
            try {
                const response = await Api.rack.loadUsersConfigurations(this.product.wid);
                this.configurations = (response?.configurations?.length ?? 0) === 0 ? null : response.configurations;
            } catch {
            }
        }
        if (this.configurations) {
            rackStartEditModalService.show({ rackProduct: this.product, configurations: this.configurations });
        } else {
            this.$router.push(`${serverContextService.settings?.rackConfiguratorPage || ''}?${UrlQueryKey.RackProductId}=${this.product.wid}`);
        }
    }
}
